import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=d9bfb672&"
import script from "./user-profile.vue?vue&type=script&lang=js&"
export * from "./user-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports